import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, withKeys as _withKeys, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { style: {"padding":"30px 30px"} }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "lock-tips-1" }, "密码本屏幕已锁定，需密码解锁。", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "lock-tips-2" }, " 欢迎使用密码管理工具-趣牛科技，安全又可靠。", -1)

import {inject, ref} from 'vue'
import {Lock} from "@element-plus/icons-vue";
import UserService from "@/api/user";
import R from "@/utils/r";
import {ElMessage} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayout',
  setup(__props) {

const userService = inject('userService') as UserService;

const isClickClose = ref(false)
const centerDialogVisible = ref(false)
let password = ref('')

const lockEvent = () => {
  userService.lockScreen().then((data: any) => {
    if (R.isSuccess(data)) {
      centerDialogVisible.value = true;
      password.value = "";
    }
  });
}

const unlockAction = () => {
  if (!password.value) {
    ElMessage({
      showClose: true,
      message: "解锁密码不能为空",
      type: 'warning',
    })
    return;
  }
  const form: any = {};
  form.password = password.value;
  userService.unlockScreen(form).then((data: any) => {
    if (R.isSuccess(data)) {
      centerDialogVisible.value = false;
      password.value = "";
    }
  });
}


return (_ctx: any,_cache: any) => {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_AppSider = _resolveComponent("AppSider")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_header, { class: "app-header" }, {
            default: _withCtx(() => [
              _createVNode(_component_AppHeader, { onLockEvent: lockEvent })
            ]),
            _: 1
          }),
          _createVNode(_component_el_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_aside, { width: "200px" }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppSider, { class: "sider" })
                ]),
                _: 1
              }),
              _createVNode(_component_el_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_main, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_view)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_footer, { class: "app-footer" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Copyright 2024 趣牛科技账户管理平台 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: centerDialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((centerDialogVisible).value = $event)),
      "close-on-press-escape": isClickClose.value,
      "close-on-click-modal": isClickClose.value,
      "show-close": isClickClose.value,
      width: "500",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_image, {
              style: {"width":"100px","height":"100px"},
              src: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
              fit: 'fill'
            }, null, 8, ["src"])
          ]),
          _hoisted_4,
          _createVNode(_component_el_input, {
            modelValue: _unref(password),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(password) ? (password).value = $event : password = $event)),
            type: "password",
            placeholder: "请输入密码解锁。",
            onKeyup: _withKeys(unlockAction, ["enter"])
          }, {
            append: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "danger",
                plain: "",
                icon: _unref(Lock),
                onClick: unlockAction
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 解锁")
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _hoisted_5
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "close-on-press-escape", "close-on-click-modal", "show-close"])
  ], 64))
}
}

})